(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar-1"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
      jQuery(document).ready(function($){
        var announceClose = $.cookie( 'announceCookie' );
    
        if( announceClose == 'true') {
          $(".announcement-bar").css({
            padding: "0",
            height: "0",
            opacity: "0",
            "z-index": "-1"
          });
        }
    
        $('.announcement-close').on("click", function(){
          $(".announcement-bar").css({
            padding: "0",
            height: "0",
            opacity: "0",
            "z-index": "-1"
          }), $.cookie("announceCookie", "true", {
              expires: 1,
              path: "/"
          });
        });
      });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-1"]) return;
  try {
    
  jQuery(document).ready(function($){
    $('.header__inline-menu li .mega-menu').hover(
        function() {
            $(this).attr('open', 'true');
            $(this).addClass('open');
        },
        function() {
            $(this).removeAttr('open');
            $(this).removeClass('open');
        }
    );
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-2"]) return;
  try {
    
  jQuery(document).ready(function($){
    $('.header__inline-menu li .mega-menu').hover(
        function() {
            $(this).attr('open', 'true');
            $(this).addClass('open');
        },
        function() {
            $(this).removeAttr('open');
            $(this).removeClass('open');
        }
    );
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recently-purchased-popup"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
      jQuery(document).ready(function($){
          $('.akeans-popup-close').bind('click',function(){
              $('.customers-recently-purchased').remove();
              $.cookie('recentPopupCookie', 'true', {expires:1, path:'/'});
          });
    
          if ($.cookie('recentPopupCookie') == 'true') {
              $('.customers-recently-purchased').remove();
          }
    
          var $items = $('.customers-recently-purchased li');
          var init_element = 0;
          var i = 0;  
          $items.removeClass('active');
          function changeActiveRandomElement() { 
              if ( i % 2 == 0) {
                  var currentItem = $items.eq(init_element);      
                  currentItem.addClass('active');
                  setTimeout(function(){ 
                    currentItem.removeClass('active')
                  }, 4000);
        
                  init_element++;
                  if($items.length == init_element) {
                    init_element = 0;
                  }
              }
              i++;
          }
          setInterval(function(){ 
            changeActiveRandomElement();
          }, 3500);
      });
  });

  } catch(e) { console.error(e); }
})();
})();
